/*
 * @Author: changkaiwu 
 * @Date: 2019-09-11 17:15:27 
 * @Last Modified by: changkaiwu
 * @Last Modified time: 2019-09-11 17:15:27 
 */
//对象数组的深拷贝
export function objDeepCopy(source) {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] = typeof source[item] === 'object' ? objDeepCopy(source[item]) : source[item];
  }
  return sourceCopy;
}

//获取本地存储
export function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name)
}
//删除本地存储
export function removeStore(name) {
  if (!name) return;
  return window.localStorage.removeItem(name)
}
//设置本地存储
export function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  return window.localStorage.setItem(name, content)
}
// 获取本地session存储
export function getSession(name) {
  if (!name) return;
  return window.sessionStorage.getItem(name)
}

//删除 本地session存储
export function removeSession(name) {
  if (!name) return;
  return window.sessionStorage.removeItem(name)
}
//删除本地session存储
export function setSession(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  return window.sessionStorage.setItem(name, content)
}
//隐藏手机或者邮箱
export function hidePhoneEmail(phone, email) {
  var phoneReg = /^(\d{3})\d*(\d{4})$/;
  var emailReg = /(\w{3})[\w-]+(@+)/;
  if (phone) {
    if (phone.length < 8) {
      return '*' + phone.substr(1)
    }
    //有可能会是邮箱
    if (phone.indexOf('@') > 0) {
      return phone.replace(emailReg, '$1****$2')
    }
    return phone.replace(phoneReg, '$1****$2')
  }
  if (email) {
    return email.replace(emailReg, '$1****$2')
  }
  return '--'
}